import { getMsalInstance } from "./msalService";
import { sideEffectLogOut, TSideEffectLogOutParams } from "../utils/common";
import { localStorageKeys } from "../utils/localStorageItems";
import { TUserAuthType } from "../api/store/commonSlice";

let logoutInProgress = false; // for hardening

export async function logoutEverywhere(options: TSideEffectLogOutParams) {
  if (logoutInProgress) return; // hardening logic
  logoutInProgress = true;

  const userAuthType = localStorage.getItem(
    localStorageKeys.user_auth_type
  ) as TUserAuthType;

  if (userAuthType === "azureAD") {
    const msal = getMsalInstance();

    if (msal) {
      const accounts = msal.getAllAccounts();

      msal.logoutRedirect({
        account: accounts[0], // passing an account is important
      });

      return; // STOP — Azure now owns navigation
    }
  }

  // Non-Azure or fallback
  sideEffectLogOut(options);
}
